import React from "react";
const About = () => {
  return (
    <React.Fragment>
      <h1>Hello world</h1>
    </React.Fragment>
  );
};

export default About;
